import { render } from "./company-basic.vue?vue&type=template&id=2f678217&scoped=true"
import script from "./company-basic.vue?vue&type=script&lang=js"
export * from "./company-basic.vue?vue&type=script&lang=js"

import "./company-basic.vue?vue&type=style&index=0&id=2f678217&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f678217"]])

export default __exports__